export default __webpack_public_path__ + "50b67b4269717b5e07c8036eede28e32.svg";